<i18n
  src="@/locales/views/agro_exporter/quality_control/container/show_export_quality_inspect.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/quality_inspect.yml" lang="yaml"></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="ph_quality_control_process_list_inspects_path"
    :params="{
      packing_house_id: packing_house_id,
      packing_house_process_id: packing_house_process_id,
      packing_process_quality_template_id: packing_process_quality_template_id,
      harvested_batch_id: harvested_batch_id,
    }"
  />
  <bread-crumbs
    :labels="[
      module_name,
      packing_house_process?.name,
      harvested_batch?.batch_code,
      quality_template?.name,
    ]"
  ></bread-crumbs>
  <template v-if="harvested_batch && quality_inspect">
    <harvested-batch-info
      v-if="harvested_batch"
      :harvested_batch="harvested_batch"
    />
    <export-quality-inspect-info
      :quality_inspect="quality_inspect"
      :harvested_batch_id="harvested_batch_id"
      :packing_process_quality_template_id="packing_process_quality_template_id"
      :destroy="destroy"
      :goToEdit="goToEdit"
    ></export-quality-inspect-info>
    <div class="mt-8">
      <tabs-container v-if="option_tabs.length > 0" v-model="option_tabs" />

      <div v-for="(option_tab, index) in option_tabs" :key="index" class="mt-6">
        <quality-group-details
          v-if="option_tab.current"
          :use_samplings="quality_template?.use_samplings"
          :quality_attributes="quality_attributes"
          :quality_samplings="quality_samplings"
          :quality_inspect="quality_inspect"
          :quality_group="current_group"
          :quality_template="quality_template"
        />
      </div>
    </div>
  </template>
  <loading-message v-else />
  <div />
</template>

<script>
import GoBackLink from "@/components/views/layout/GoBackLink.vue";
import ContainerQualityRequester from "@/views/packing_house/requesters/quality_control/process/show_inspect.js";
import ExportQualityInspectInfo from "@/components/views/packing_house/quality_control/process/ExportQualityInspectInfo.vue";
import HarvestedBatchInfo from "@/components/views/packing_house/quality_control/process/HarvestedBatchInfo.vue";
import QualityGroupDetails from "@/components/views/packing_house/quality_control/process/show_inspect/QualityGroupDetails.vue";
import BreadCrumbs from "@/components/views/layout/BreadCrumbs.vue";
export default {
  name: "ShowInspect",
  components: {
    GoBackLink,
    HarvestedBatchInfo,
    ExportQualityInspectInfo,
    BreadCrumbs,
    QualityGroupDetails,
  },
  data() {
    return {
      quality_inspect: null,
      quality_template: {},
      packing_house_process: {},
      harvested_batch: null,
      option_tabs: [],
      quality_groups: [],
      quality_sampling_details: [],
      ranges: [],
      sampling_ranges: [],
    };
  },
  props: {
    harvested_batch_id: {
      required: true,
    },
    quality_inspect_id: {
      required: true,
    },
    packing_process_quality_template_id: {
      required: true,
    },
    packing_house_process_id: {
      required: true,
    },
    packing_house_id: {
      required: true,
    },
  },
  created() {
    this.checkIfAuthenticated();
    this.fetchPackingHouseProcess();
    this.fetchHarvestedBatch();
    this.fetchExporterQualityTemplate();
    this.fetchExporterQualityInspect().then(() => {
      this.fetchExportQualityGroups();
    });
  },
  computed: {
    find_current_tab() {
      return this.option_tabs.find((option_tab) => option_tab.current);
    },
    current_group: function () {
      return this.quality_groups.find(
        (quality_group) => quality_group.id == this.find_current_tab?.id
      );
    },
    quality_attributes: function () {
      return this.quality_groups
        .find((quality_group) => quality_group.id == this.find_current_tab?.id)
        .quality_attributes.sort((a, b) => a.position - b.position);
    },
    quality_samplings: function () {
      let quality_samplings = [];
      for (
        let sampling = 1;
        sampling <= this.quality_inspect.samplings;
        sampling++
      ) {
        let quality_sampling = this.quality_inspect.quality_samplings.find(
          (quality_sampling) => quality_sampling.sampling == sampling
        );
        quality_samplings.push(quality_sampling || {});
      }
      return quality_samplings;
    },
  },
  methods: {
    fetchPackingHouseProcess: async function () {
      let response = await ContainerQualityRequester.fetchPackingHouseProcess({
        packing_house_id: this.packing_house_id,
        packing_house_process_id: this.packing_house_process_id,
      });
      this.packing_house_process = response.data;
    },
    getGeneral: function (inspect, attr) {
      return inspect.quality_generals.find(
        (quality_general) => quality_general.quality_attribute_id === attr.id
      );
    },
    goToEdit: function () {
      this.$router.push({
        name: "ph_quality_control_process_edit_inspect_path",
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
          harvested_batch_id: this.harvested_batch_id,
          quality_inspect_id: this.quality_inspect_id,
        },
      });
    },
    switchTab: function (tabIdx) {
      for (let i = 0; i < this.option_tabs.length; i++) {
        this.option_tabs[i].current = false;
      }
      this.option_tabs[tabIdx].current = true;
    },
    fetchHarvestedBatch: async function () {
      let response = await ContainerQualityRequester.fetchHarvestedBatch({
        packing_house_id: this.packing_house_id,
        packing_house_process_id: this.packing_house_process_id,
        harvested_batch_id: this.harvested_batch_id,
      });
      this.harvested_batch = response.data;
    },
    fetchExporterQualityTemplate: async function () {
      let response =
        await ContainerQualityRequester.fetchExporterQualityTemplate({
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
          harvested_batch_id: this.harvested_batch_id,
          packing_process_quality_template_id:
            this.packing_process_quality_template_id,
          quality_inspect_id: this.quality_inspect_id,
        });
      this.quality_template = response.data;
    },
    fetchExporterQualityInspect: async function () {
      let response =
        await ContainerQualityRequester.fetchExporterQualityInspect({
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
          harvested_batch_id: this.harvested_batch_id,
          packing_process_quality_template_id:
            this.packing_process_quality_template_id,
          quality_inspect_id: this.quality_inspect_id,
        });
      this.quality_inspect = response.data;
    },
    destroy: async function () {
      try {
        let response = await ContainerQualityRequester.destroy({
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
          harvested_batch_id: this.harvested_batch_id,
          packing_process_quality_template_id:
            this.packing_process_quality_template_id,
          quality_inspect_id: this.quality_inspect_id,
        });
        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.goToListInspects();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields,
          });
        }
      }
    },
    listExportQualityGroups: function () {
      this.quality_groups = this.quality_inspect.quality_samplings
        .map((quality_sampling) => quality_sampling.quality_sampling_groups)
        .flat()
        .map((quality_sampling_group) => quality_sampling_group.quality_group)
        .reduce(
          (quality_groups, quality_group) =>
            quality_groups.find((item) => item.id === quality_group.id)
              ? quality_groups
              : [...quality_groups, quality_group],
          []
        );
    },
    listExporterQualityAttributes: async function (export_quality_group_id) {
      let response =
        await ContainerQualityRequester.fetchExporterQualityAttributes(
          export_quality_group_id
        );
      this.quality_attributes = response.data.sort(
        (a, b) => a.position - b.position
      );
    },
    findExportQualitySamplingDetailValue: function (quality_attribute_id) {
      let quality_sampling_detail = this.quality_sampling_details.find(
        (quality_sampling_detail) =>
          quality_sampling_detail.quality_attribute_id === quality_attribute_id
      );

      return (
        quality_sampling_detail?.value ||
        quality_sampling_detail.value_float ||
        quality_sampling_detail.value_bool
      );
    },
    fetchExportQualityGroups: async function () {
      let response = await ContainerQualityRequester.fetchExportQualityGroups({
        packing_house_id: this.packing_house_id,
        packing_house_process_id: this.packing_house_process_id,
        packing_process_quality_template_id:
          this.packing_process_quality_template_id,
      });
      this.quality_groups = response.data;
      this.option_tabs = this.quality_groups.map((eq_group) => {
        return {
          id: eq_group.id,
          name: eq_group.name,
          icon: "fas fa-eye",
          current: this.quality_groups[0].id === eq_group.id,
        };
      });
    },
    goToListInspects: function () {
      this.$router.push({
        name: "ph_quality_control_process_list_inspects_path",
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
          packing_process_quality_template_id:
            this.packing_process_quality_template_id,
          harvested_batch_id: this.harvested_batch_id,
        },
      });
    },
  },
};
</script>
